export const SET_ADMINS = (data) => {
  return {
    type: "SET_ADMINS",
    payload: data,
  };
};
export const SET_ADMIN = (data) => {
  return {
    type: "SET_ADMIN",
    payload: data,
  };
};
export const ADD_ADMIN = (data) => {
  return {
    type: "ADD_ADMIN",
    payload: data,
  };
};
export const SET_FLEET_USER = (data) => {
  return {
    type: "SET_FLEET_USER",
    payload: data,
  };
};
export const SET_USER_FLEETS = (data) => {
  return {
    type: "SET_USER_FLEETS",
    payload: data,
  };
};
export const SET_USER_NEW_FLEETS = (data) => {
  return {
    type: "SET_USER_NEW_FLEETS",
    payload: data,
  };
};
export const UPDATE_ADMIN = (data) => {
  return {
    type: "UPDATE_ADMIN",
    payload: data,
  };
};
export const DELETE_ADMIN = (data) => {
  return {
    type: "DELETE_ADMIN",
    payload: data,
  };
};

export const SET_USERS = (data) => {
  return {
    type: "SET_USERS",
    payload: data,
  };
};

export const ADD_USER = (data) => {
  return {
    type: "ADD_USER",
    payload: data,
  };
};
export const UPDATE_USER = (data) => {
  return {
    type: "UPDATE_USER",
    payload: data,
  };
};
export const DELETE_USER = (data) => {
  return {
    type: "DELETE_USER",
    payload: data,
  };
};
